import { Button, ButtonProps } from '@mui/material';
import React from 'react';

const ActionButton = React.forwardRef(function SvgButton(
	props: ButtonProps,
	ref: React.ForwardedRef<any>,
) {
	return (
		<Button
			{...props}
			size='small'
			variant='outlined'
			sx={{ minWidth: 0, height: 32, width: 32 }}
			ref={ref}
		/>
	);
});

export default ActionButton;
